// extracted by mini-css-extract-plugin
export default {"url":"BreadCrumb_url__MQDmP"};